import Vue from 'vue'
import Vuex from 'vuex'

import dsInfo from './modules/DsInfo'
import setting from './modules/setting'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    dsInfo,
    setting
  }
})
